import { makeVar, useReactiveVar } from '@apollo/client';
import { localStorageService } from '@/services/local-storage-service';
import { clearTerminalTabNewsActivity } from './terminal-tab-news-activity';
import { useTerminalTabs } from './use-terminal-tabs';

const activeTerminalTabIdKey = 'active-terminal-tab-id';

export const activeTerminalTabIdVar = makeVar<string | null>(
  localStorageService.getItem(activeTerminalTabIdKey),
);

export const setActiveTerminalTabId = (id: string): void => {
  if (id === activeTerminalTabIdVar()) return;
  activeTerminalTabIdVar(id);
  localStorageService.setItem(activeTerminalTabIdKey, id);
  clearTerminalTabNewsActivity(id);
};

// Stored id when still valid, else first tab — single source of truth for grid, tabs, shortcuts.
export const useActiveTerminalTabId = (): string | undefined => {
  const stored = useReactiveVar(activeTerminalTabIdVar);
  const tabs = useTerminalTabs();
  return tabs.some((tab) => tab.id === stored) ? stored! : tabs[0]?.id;
};
